import React, { useState, useEffect } from 'react'
import SBNav from '../../shared/components/SideBarNav/SBNav'
import './comingsoon.scss'
import Footer from '../../components/Footer/Footer'

const ComingSoon = () => {

    useEffect(() => {
        document.title = 'Coming Soon'
    }, [])

    const [nav, openNav] = useState(false);


    useEffect(() => {
        if (!nav) {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            return;
        }

        const scrollY = window.scrollY;

        document.documentElement.classList.add("nav-blur");

        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";

        return () => {
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            window.scrollTo(0, scrollY);
        };
    }, [nav]);


    return (
        <div id='coming-soon-page'>

            <div className='nav-wrapper'>
                <div className='nav-2'>

                    <img src='images/flashroom-logo-light.png' height="44px" />

                    <div className='hamburger-menu-2' onClick={() => openNav(true)}>
                        <div />
                        <div />
                        <div />
                    </div>

                </div>
            </div>


            <div className={`nav-cont ${nav ? 'nav-open' : 'nav-closed'}`}>

                <div className='standard-xi-cont'

                    onClick={() => openNav(false)}
                >

                    <svg className="x-icon-sbn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>

                </div>

                <SBNav />

            </div>


            <div className="coming-soon-content">
                <div className="coming-soon-panel">
                    <div className="cs-top">
                        <div className="cs-badge">Coming Soon</div>
                        <h1>
                            FlashRoom is expanding beyond sharing
                            <span> into learning</span>.
                        </h1>
                        <p className="cs-sub">
                            Soon, you will be able to run code in browser and create quizzes for students which can include coding challenges and questions.
                        </p>


                    </div>

                    <div className="cs-grid">
                        <div className="cs-card">
                            <div className="cs-card-title">In-browser Code Runner</div>
                            <p>
                                Execute snippets directly in the room so students can test ideas instantly. perfect for demos,
                                challenges, and live teaching.
                            </p>
                            <ul>
                                <li>Run + reset with one click</li>
                                <li>Starter templates per lesson</li>
                            </ul>
                        </div>

                        <div className="cs-card">
                            <div className="cs-card-title">Quizzes & Checkpoints</div>
                            <p>
                                Add quick questions to keep learners engaged. Great for belt classes, workshops, and warmups.
                            </p>
                            <ul>
                                <li>Multiple choice & short answer</li>
                                <li>Instant feedback</li>
                                <li>Teacher view for progress</li>
                            </ul>
                        </div>

                        <div className="cs-card">
                            <div className="cs-card-title">Lesson Mode</div>
                            <p>
                                Turn a room into a guided flow: steps, examples, files, and notes — all organized and easy to follow.
                            </p>
                            <ul>
                                <li>Step-by-step modules</li>
                                <li>Attach files & snippets</li>
                                <li>Clean “follow along” layout</li>
                            </ul>
                        </div>
                    </div>

                    <div className="cs-divider" />

                    <div className="cs-bottom">



                    </div>
                </div>
            </div>

            <Footer />


        </div>
    )
}

export default ComingSoon
